<template>
    <div>
        <h6 style="font-weight: bold">{{ title }}</h6>

        <div
            v-for="(shipmentAesFiling) in shipmentAesFilings"
            v-bind:key="shipmentAesFiling.id"
        >
            <span>{{$t('history.label.ItnNumber')}}: {{shipmentAesFiling.itnNumber}}</span>
            <br />
            <span>{{$t('history.label.Errors')}}</span>
            <br />
            <ul>
                <li
                    v-for="(error) in shipmentAesFiling.errors"
                    v-bind:key="error"
                >{{error}}</li>
            </ul>
        </div>
    </div>
</template>
<script>
  import localization from '@/mixins/localizationMixin';
  export default {
      components: {},

      mixins: [localization],

      props: {
          title: { type: String, required: true },
          shipmentAesFilings: { required: true },
      },

      data() {
          return {};
      },

      methods: {},
  };
</script>

<style></style>
